export class GeoLinkUtil {
  public static toGeoLink({ latitude, longitude }: { latitude: number; longitude: number }) {
    return `geo:${latitude},${longitude}?q=${latitude},${longitude}&addr=${latitude},${longitude}`;
  }
}
